export const KG_CO2_PER_TREE = 20;
